import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserMfaInfo, verifySession } from "src/store/slices/user.slice";
import Cookies from "universal-cookie";
// import { getTokenDcrypted, setToken } from "../auth/auth.service";
import MfaComponent from "../components/mfa/mfa.component";
import ModalComponent from "../components/modal/modal.component";
import { completeAuthorization } from "./openid-manager";
import { authCallbackPath } from "./openid-settings";

export const OpenIdCallback: FC = (props: any) => {
  const url = window.location.href;
  const authCallback = authCallbackPath as any;
  const isOpenIdCallback = url.includes(authCallback);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => state.otp.isOtpVerified);

  const handleFinalRedirect = () => {
    const redirectPath = localStorage.getItem("postRefreshRedirect");
    const postLoginRedirect = localStorage.getItem("postLoginRedirect");

    // Priority 1: Refresh redirect
    if (redirectPath) {
      localStorage.removeItem("postRefreshRedirect");
      navigate(redirectPath, { replace: true });
    }
    // Priority 2: Post-login redirect
    else if (postLoginRedirect) {
      localStorage.removeItem("postLoginRedirect");
      navigate(postLoginRedirect, { replace: true });
    }
    // Default redirect
    else {
      navigate("/dashboard", { replace: true });
    }
  };

  const onSubmitMfaOtp = () => {
    // setToken(localStorage.getItem("temp-token"));
    localStorage.setItem("isLogout", JSON.stringify(false));
    setIsOtpModalOpen(false);
    handleFinalRedirect();
  };

  const mfaActionConfig = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  useEffect(() => {
    if (isOpenIdCallback) {
      const processAuthorization = async () => {
        try {
          const verifyResult = await dispatch(verifySession()).unwrap();

          localStorage.setItem("hdbUserInfo", JSON.stringify(verifyResult));

          // Handle MFA flow
          if (
            verifyResult[
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
            ]
          ) {
            const mfaRes = await dispatch(getUserMfaInfo()).unwrap();

            if (mfaRes?.isMfaEnabled) {
              setIsOtpModalOpen(true);
            } else {
              // Proceed without MFA
              localStorage.setItem("isLogout", JSON.stringify(false));
              setIsOtpModalOpen(false);
              localStorage.setItem("signOutFromIdleSession", "false");
              handleFinalRedirect();
            }
          } else {
            throw new Error("User nameidentifier is not found in session");
          }
        } catch (error: any) {
          console.error("Authorization process failed:", error);

          navigate("/login-error");
        }
      };

      processAuthorization();
    } else {
      const idleModalRefreshRedirect = localStorage.getItem(
        "idleModalRefreshRedirect"
      );

      if (idleModalRefreshRedirect) {
        localStorage.removeItem("idleModalRefreshRedirect");
        navigate(idleModalRefreshRedirect, { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [isOpenIdCallback]);

  // if (isOpenIdCallback) return null;

  return (
    <>
      {isOTPModalOpen ? (
        <>
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={true}
            backdropClassName="custom-backdrop"
            isClosable={false}
          >
            <MfaComponent />
          </ModalComponent>
        </>
      ) : (
        <> {props.children} </>
      )}
    </>
  );
};
